import React from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import InfoIcon from '@mui/icons-material/InfoOutlined';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    popover: {
      pointerEvents: 'none',
    },
    paper: {
      padding: theme.spacing(1),
    },
    table: {},
    wrapIcon: {
      verticalAlign: 'middle',
      display: 'inline-flex',
    },
  })
);

export interface IPopoverDataItem {
  name: string;
  value: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IPopoverData extends Array<IPopoverDataItem> {}

export interface IPopoverOnMouseOver {
  displayValue?: any;
  showPopover?: boolean;
  showPopoverIcon?: boolean;
  popoverTitle?: string;
  popoverData: IPopoverData;
}

export function PopoverOnMouseOver({
  displayValue = '',
  showPopover = false,
  showPopoverIcon = false,
  popoverTitle = '',
  popoverData,
}: IPopoverOnMouseOver) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <Typography
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        className={classes.wrapIcon}
      >
        {displayValue}&nbsp;
        {showPopoverIcon && <InfoIcon />}
      </Typography>
      {showPopover && (
        <Popover
          id="mouse-over-popover"
          className={classes.popover}
          classes={{
            paper: classes.paper,
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          {popoverTitle?.length > 0 && (
            <Typography variant="h6" align="center">
              {popoverTitle}
            </Typography>
          )}
          <TableContainer component={Paper}>
            <Table
              className={classes.table}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow>
                  {popoverData.map((element, i) => (
                    <TableCell align="center" key={i}>
                      {element.name}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow key={1}>
                  {popoverData.map((element, i) => (
                    <TableCell align="center" key={i * 10}>
                      {element.value}
                    </TableCell>
                  ))}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Popover>
      )}
    </div>
  );
}
